export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_767___TO_GOAL': '% to Goal',
    '_768___TO_TARGET': '% to Target',
    '_725_ACTUAL': 'Actual',
    '_7334_BEHAVIOUR': 'Behaviour',
    '_7437_BOTH': 'Both',
    '_763_CLOSE': 'Close',
    '_7353_EFFORT_DEMONSTRATED': 'Effort Demonstrated',
    '_7447_FAILED_TO_LOAD_DATA': 'Failed to Load Data',
    '_7351_FOCUS_EVALUATED': 'Focus Evaluated',
    '_721_GOAL': 'Goal',
    '_7352_HIDE_EVALUATIONS': 'Hide evaluations',
    '_7350_INTERACTION_DATE': 'Interaction Date',
    '_7349_INTERACTION_TYPE': 'Interaction Type',
    '_842_N_A': 'N/A',
    '_7336_SUB_BEHAVIOUR': 'Tactic',
    '_726_TARGET': 'Target',
    '_9619_SELECTED_KPIS_': 'Selected Metrics:',
    '_9622_BEHAVIOUR___SUB_BEHAVIOUR_FOCUS': 'Behaviour - Tactic Focus',
    '_9623_OBSERVE_A_NEW_INTERACTION': 'Observe a new interaction',
    '_9624_ADD_ANOTHER_METRIC': 'Add another metric',
    '_9779_EXPECTED_ACHIEVEMENT_DATE': 'Expected Achievement Date',
    '_7454_KPIS': 'Goals',
    '_9625_CREATE_A_NEW_FOCUS': 'Create a new Focus',
    '_9783_DATE_': 'Date:',
    '_965_DATE': 'Date',
    '_9512_INVALID_DATE_': 'Invalid Date.',
    '_121_CANCEL': 'Cancel',
    '_9630_SHARE': 'Share',
    '_7425_EDIT': 'Edit',
    '_7424_DELETE': 'Delete',
    '_9415_PUBLISH': 'Publish',
    '_9416_SAVE_DRAFT': 'Save Draft',
    '_9417_DURATION_': 'Duration:',
    '_9631_PREV': 'Prev',
    '_9632_NEXT': 'Next',
    '_9634_LINK': 'Link',
    '_9418_UNLINK': 'Unlink',
    '_9701_READ_ONLY': 'Read Only',
    '_9702_EDIT_MODE': 'Edit Mode',
    '_9637_EXIT_EDIT_MODE': 'Exit Edit Mode',
    '_9548_OBSERVATION': 'Observation',
    '_9419_TYPE_': 'Type:',
    '_9420_STATUS_': 'Status:',
    '_9567_OPPORTUNITY_TO_DEMONSTRATE': 'Opportunity to Demonstrate',
    '_9568_WILLINGNESS_TO_TRY': 'Willingness to Try',
    '_7317_PROFICIENCY': 'Proficiency',
    '_9644_PROFICIENCY_SCORE': 'Proficiency Score',
    '_9645_CONSISTENCY_SCORE': 'Consistency Score',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9646_EVALUATE_INTERACTION_FOCUS': 'Evaluate Interaction Focus',
    '_9113_PUBLISHED': 'Published',
    '_9650_THIS_FOCUS_ALREADY_EXISTS__DO_YOU_WANT_TO_MOVE_THE_ITEMS_TO_THIS_FOCUS_': 'This focus already exists. Do you want to move the items to this focus?',
    '_9651_A_NEW_FOCUS_CONTAINER_HAS_BEEN_CREATED_WITH_YOUR_FOCUS_SELECTION': 'A new focus container has been created with your focus selection',
    '_9425_OK': 'OK',
    '_9652_INTERACTION_REF': 'Interaction Ref',
    '_9703_INTERACTION_TIME': 'Interaction Time',
    '_9704_INTERACTION_PURPOSE': 'Interaction Purpose',
    '_9705_ADD_AN_INTERACTION_NOTE': 'Add an Interaction note',
    '_9426_ACTIVE_GOALS': 'Active Goals',
    '_9654_FOCUS_METRIC': 'Focus Metric',
    '_9655_NO_ACTIVE_GOALS': 'NO ACTIVE GOALS',
    '_9656_NO_FOCUS_METRIC': 'NO FOCUS METRICS',
    '_9454_ACTIVE_GOAL': 'Active Goal',
    '_9476_DRAFT': 'Draft',
    '_9658_SET_FOCUS': 'Set Focus',
    '_9660_COPY_NOTES_TO_NEW_FOCUS': 'Copy notes to New Focus',
    '_9661_SCORES_FROM_THIS_SESSION': 'Scores from This Session',
    '_9662_PENDING_OVERALL': 'Pending Overall',
    '_9579_FOCUS_CONTAINER__UNFOCUSED_': 'Focus Container (Unfocused)',
    '_9663_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FOCUS_CONTAINER_': 'Are you sure you want to delete this Focus Container?',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9665_RESET': 'Reset',
    '_9666_ARE_YOU_SURE_YOU_WANT_TO_RESET_EVALUATION_TO_PREVIOUS_VALUE_': 'You are about to reset your evaluation. This will remove your score from this interaction.',
    '_9667_CHANGE_FOCUS': 'Change Focus',
    '_9668_UPDATE_COMMITMENT': 'Update Commitment',
    '_534_EVALUATION': 'Evaluation',
    '_9669_SELECT_A_VALUE_FOR_WILLINGNESS_TO_TRY': 'Select a value for Willingness to Try',
    '_9670_SELECT_A_VALUE_FOR_THE_PROFICIENCY_SCORE': 'Select a value for the Proficiency Score',
    '_9489_YOU_ARE_LEAVING_THIS_SESSION_': 'You are leaving this session.',
    '_9490_LEAVE': 'Leave',
    '_9491_STAY': 'Stay',
    '_9492_WARNING': 'Warning',
    '_9494_YOU_ARE_SELECTING_A_DIFFERENT_METRIC__THIS_WILL_TAKE_YOU_OUTSIDE_THIS_FORM_': 'You are selecting a different metric, this will take you outside this form.',
    '_9671_COMMIT': 'Commit',
    '_9672_JUST_PUBLISH': 'Just Publish',
    '_9673_THE_FOCUS_YOU_SELECTED_IN_THE_OBSERVATION_WILL_BE_USED_FOR_THE_COMMITMENT__DO_YOU_WANT_TO_PROCEED_': 'The Focus you selected in the Observation will be used for the Commitment. Do you want to Proceed?',
    '_9674_YOU_ARE_PUBLISHING_AN_OBSERVATION__DO_YOU_WANT_TO_UPDATE_OR_CREATE_A_COMMITMENT_': 'You are publishing an Observation. Do you want to update or create a commitment?',
    '_9583_DO_YOU_WANT_TO_EDIT_THIS_OBSERVATION_': 'Do you want to edit this observation?',
    '_9675_DO_YOU_WANT_TO_EDIT_THE_COMMITMENT_': 'Do you want to edit the commitment?',
    '_9556_DO_YOU_WANT_TO_CREATE_A_NEW_COMMITMENT_': 'Do you want to create a new commitment?',
    '_9497_DATE___TIME_': 'Date & Time:',
    '_9706_THE_OBSERVATION_WAS_SAVED_': 'The observation was saved.',
    '_704_UNKNOWN_ERROR': 'Unknown error',
    '_9707_OBSERVATION_WILL_BE_SAVED_AS_DRAFT': 'Observation will be saved as Draft',
    '_9708_DO_YOU_WANT_TO_SHARE_THIS_OBSERVATION_WITH_THE_PERFORMER_': 'Do you want to share this observation with the performer?',
    '_9709_DO_YOU_WANT_TO_CANCEL_THIS_OBSERVATION_': 'Do you want to cancel this observation?',
    '_9710_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_OBSERVATION_': 'Are you sure you want to delete this observation?',
    '_9711_ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_METRIC_': 'Are you sure you want to remove this metric?',
    '_9712_PLEASE_CHECK_THE_ENTERED_OBSERVATION_DATE_': 'Please check the entered observation date.',
    '_9713_THE_OBSERVATION_DATE_CANNOT_BE_IN_THE_FUTURE_': 'The observation date cannot be in the future.',
    '_9714_DURATION_RANGE': 'The duration must be between 1 and 480.',
    '_9715_QUEUE_': 'Queue:',
    '_9716_YOU_CANNOT_PUBLISH_THIS_OBSERVATION_SESSION': 'You cannot Publish this Observation session',
    '_9717_UPDATE_MANDATORY_FIELD_S__LISTED_BELOW__MANDATORY_FIELDS_WILL_': 'Update mandatory field(s) listed below. Mandatory fields will be highlighted with a red outline in all forms and containers that are impacted.',
    '_9718_FOCUS_CONTAINER': 'Focus Container',
    '_9719_SELECT_A_FOCUS_TO_BE_ASSIGNED_AND_ONE_OF_THE_FOLLOWING_BELOW_': 'Select a Focus to be assigned AND one of the following below:',
    '_9720_PERFORM_ONE_OF_THE_FOLLOWING_': 'Perform one of the following:',
    '_9698_NOTE': 'Note',
    '_9721_PLEASE_ENTER_TEXT_FOR_AT_LEAST_ONE_NOTE': 'Please enter text for at least one note',
    '_9722_EVALUATION_INTERACTION_FOCUS': 'Evaluation Interaction Focus',
    '_9723_EVALUATE_THE_FOCUS': 'Evaluate the Focus',
    '_9724_OR': 'or',
    '_9725_THE_HIGHLIGHTED_CONTAINERS_FROM_THE_SESSION': 'the highlighted containers from the session',
    '_9726_THERE_IS_NO_MATCHING_FOCUS_TO_LINK__DO_YOU_WANT_TO_START_A_NEW_OBSERVATION_': 'There is no matching focus to link, do you want to start a new observation?',
    '_9699_DISCARD_CHANGES_': 'Discard changes?',
    '_9727_COMMIT_FOCUS_CONTAINERS': 'Commit Focus Containers',
    '_9422_BEHAVIOUR_': 'Behaviour:',
    '_9423_SUB_BEHAVIOUR_': 'Tactic:',
    '_9728_LINK_OBSERVATION': 'Link Observation',
    '_9729_ACTIVE_FOCUS_ES_': 'Active Focus(es)',
    '_9730_NEW_FOCUS_ES_': 'New Focus(es)',
    '_9731_DRAFT_COMMITMENT': 'Draft Commitment',
    '_640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_': '{{field_label}} is a required field. Please enter a {{field_label}}.',
    '_7227__FIELD_LABEL__MUST_BE_LESS_THAN_OR_EQUAL_TO__REQUIREDLENGTH__CHARACTERS_': '{{field_label}} must be less than or equal to {{requiredLength}} characters.',
    '_9734_INVALID_TIME_': 'Invalid time.',
    '_9735__FIELD_LABEL__CANNOT_BE_IN_THE_FUTURE_': '{{field_label}} cannot be in the future.',
    '_9745_TECHNICAL_ISSUE': 'Technical Issue',
    '_9825_START_COMMITMENT': 'Start Commitment',
    '_11044_WOULD_YOU_LIKE_TO_PUBLISH_THIS_OBSERVATION_AND_CONTINUE': 'Would you like to publish this observation and continue making notes from this transcript or publish this observation and close the transcript',
    '_11039_PUBLISH_AND_CONTINUE': 'Publish - Stay on Transcript',
    '_11040_PUBLISH_AND_CLOSE': 'Publish - Go to Commitment'
};
